@if (!formsDisabled) {
    <table
        class="table table-center table-add-row table-last-col"
        [class.disabled]="formsDisabled"
        [class.table-last-col]="!formsDisabled">
        <tr>
            <th class="wiper-selection" colspan="3">Materieel</th>
            <th class="type-vzw">Type vzw</th>
            @if (Functionalities.TransportplanningManagement | hasFunctionality) {
                <th>Machinist</th>
            }
            <th class="tabledate">Datum</th>
            <th class="tabletime">Tijdsblok</th>
            <th class="comment">Wegdekreiniger</th>
            <th class="comment">Opmerking</th>
            @if (!formsDisabled) {
                <th></th>
            }
        </tr>
        @for (planning of planningEntitiesList; track planning) {
            <tr [formGroup]="planningEntitiesForm.get(planning)">
                <td
                    class="wiper-selection"
                    [attr.colspan]="!planning.entity || planning.entity.use_once ? '3' : '1'"
                    [class.use-multiple]="planning.entity && !planning.entity.use_once"
                    [matTooltip]="planning?.entity?.name">
                    <div class="d-flex">
                        <mat-select formControlName="entity_id" placeholder="veeg/zuigwagen" panelWidth="325px">
                            @for (wipetruck of entities; track wipetruck) {
                                <mat-option
                                    [disabled]="
                                        wipetruck.notAvailable ||
                                        (wipetruck.use_once &&
                                            wipetruck.usedHere &&
                                            wipetruck.id !== planningEntitiesForm.get(planning).get('entity_id').value)
                                    "
                                    [value]="wipetruck.id">
                                    {{ wipetruck.name }}
                                </mat-option>
                            }
                        </mat-select>
                    </div>
                </td>
                @if (planning.entity && !planning.entity.use_once) {
                    <td class="wiper-selection">
                        <div class="d-flex">
                            <mat-select formControlName="hiring_id" placeholder="Inhuur" panelWidth="400px">
                                @for (hiring of hiringList; track hiring) {
                                    <mat-option [value]="hiring.id">
                                        {{ hiring.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </div>
                    </td>
                }
                @if (planning.entity && !planning.entity.use_once) {
                    <td class="text-input hire-name">
                        <input
                            class="row-input"
                            autocomplete="off"
                            formControlName="name"
                            matInput
                            placeholder="Naam"
                            type="text" />
                    </td>
                }
                <td class="type-vzw">
                    <input
                        class="row-input"
                        [matAutocomplete]="typeAutocomplete"
                        type="text"
                        placeholder="Type veeg- zuigwagen"
                        aria-label="Type veeg- zuigwagen"
                        formControlName="type" />
                    <mat-autocomplete #typeAutocomplete="matAutocomplete" autoActiveFirstOption panelWidth="225px">
                        <mat-option value="RAVO">RAVO</mat-option>
                        <mat-option value="RAVO 3e borstel">RAVO 3e borstel</mat-option>
                        <mat-option value="RAVO rolbezem">RAVO rolbezem</mat-option>
                        <mat-option value="RAVO reiniger">RAVO reiniger</mat-option>
                        <mat-option value="VZW klein">VZW klein</mat-option>
                        <mat-option value="VZW rolbezem">VZW rolbezem</mat-option>
                        <mat-option value="VZW groot rolbezem">VZW groot rolbezem</mat-option>
                        <mat-option value="VZW-WDR">VZW-WDR</mat-option>
                        <mat-option value="VZW-WDR rolbezem">VZW-WDR rolbezem</mat-option>
                    </mat-autocomplete>
                </td>
                @if (Functionalities.TransportplanningManagement | hasFunctionality) {
                    <td
                        class="select driver ng-select-red"
                        [matTooltip]="
                            planning.driver_user_id ? (drivers | byId: planning.driver_user_id)?.name : planning?.driver
                        "
                        [class.red-error]="planningEntitiesForm.get(planning).get('driver_user_id').invalid">
                        <ng-select placeholder="Chauffeur" formControlName="driver_user_id">
                            @for (user of drivers; track user) {
                                <ng-option [value]="user.id" [innerHTML]="user.name"></ng-option>
                            }
                        </ng-select>
                    </td>
                }
                <ng-container formGroupName="date">
                    <td>
                        <input
                            class="row-input"
                            [matDatepicker]="pickerStart"
                            [max]="mainPlanning.enddate"
                            [min]="minDatePicker"
                            (focus)="pickerStart.open()"
                            (click)="pickerStart.open()"
                            formControlName="date"
                            placeholder="Datum" />
                        <mat-datepicker #pickerStart></mat-datepicker>
                    </td>
                    <td
                        class="tabletime"
                        [class.error-background]="
                            planningEntitiesForm.get(planning).errors &&
                            planningEntitiesForm.get(planning).errors.notAvailable
                        "
                        [matTooltip]="
                            'wipetrucktime' + (planningEntitiesForm.get(planning).get('entity_id').value ? '' : '-na')
                                | tt
                        ">
                        <div class="timepicker">
                            <mat-select formControlName="begintime" placeholder="van" panelWidth="200px">
                                <mat-select-trigger>
                                    <small>{{ planning.begindate | date: 'EEE' }}</small>
                                    {{ planning.begindate | date: 'HH:mm' }}
                                </mat-select-trigger>
                                @if (startTimesEntity.has(planning)) {
                                    @for (day of startTimesEntity.get(planning); track day.datetime) {
                                        <mat-optgroup label="{{ day.datetime | date: 'EEEE d MMM' }}">
                                            @for (time of day.options; track time) {
                                                <mat-option [disabled]="time.notAvailable" [value]="time.time">
                                                    {{ time.datetime | date: 'HH:mm' }}
                                                    <small>{{ time.datetime | date: 'EEE d MMM' }}</small>
                                                </mat-option>
                                            }
                                        </mat-optgroup>
                                    }
                                }
                            </mat-select>
                            <span>-</span>
                            <mat-select formControlName="endtime" placeholder="tot" panelWidth="200px">
                                <mat-select-trigger>
                                    <small>{{ planning.enddate | date: 'EEE' }}</small>
                                    {{ planning.enddate | date: 'HH:mm' }}
                                </mat-select-trigger>
                                @if (endTimesEntity.has(planning)) {
                                    @for (day of endTimesEntity.get(planning); track day.datetime) {
                                        <mat-optgroup label="{{ day.datetime | date: 'EEEE d MMM' }}">
                                            @for (time of day.options; track time) {
                                                <mat-option [disabled]="time.notAvailable" [value]="time.time">
                                                    {{ time.datetime | date: 'HH:mm' }}
                                                    <small>{{ time.datetime | date: 'EEE d MMM' }}</small>
                                                </mat-option>
                                            }
                                        </mat-optgroup>
                                    }
                                }
                            </mat-select>
                        </div>
                    </td>
                </ng-container>
                <td class="text-input" [matTooltip]="planning?.wdr">
                    <input
                        class="row-input"
                        autocomplete="off"
                        formControlName="wdr"
                        maxlength="300"
                        placeholder="Wegdekreiniger"
                        type="text" />
                </td>
                <td class="text-input" [matTooltip]="planning?.comment">
                    <input
                        class="row-input"
                        autocomplete="off"
                        formControlName="comment"
                        maxlength="300"
                        placeholder="Opmerking"
                        type="text" />
                </td>
                @if (!formsDisabled) {
                    <td>
                        <button
                            class="icon-button-medium"
                            (click)="removeEntityPlanning(planning)"
                            color="warn"
                            mat-icon-button
                            matTooltip="Verwijder"
                            matTooltipClass="warn-background"
                            matTooltipPosition="right"
                            tabindex="-1">
                            <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                        </button>
                    </td>
                }
            </tr>
        }
        <tr [hidden]="formsDisabled">
            <td [colSpan]="(Functionalities.TransportplanningManagement | hasFunctionality) ? 9 : 8">
                @if (!addButtonDisabled) {
                    <button class="w-100" (click)="addEntityPlanning()" color="primary" mat-button>
                        Veeg-/zuigwagen toevoegen <i class="fas fa-plus"></i>
                    </button>
                }
                @if (addButtonDisabled) {
                    <div class="p-2" [class.warn-color]="warnIconLightUp">
                        <i class="fas fa-exclamation-triangle"></i> Er zijn geen veeg-/zuigwagens beschikbaar
                    </div>
                }
            </td>
            @if (!formsDisabled) {
                <td></td>
            }
        </tr>
    </table>
}
@if (formsDisabled) {
    <table class="table table-center mb-0">
        <tr>
            <th class="wiper-selection">Type</th>
            <th width="100">Datum</th>
            <th class="tabletime">Tijdsblok</th>
            <th>Wegdekreiniger</th>
            <th>Opmerking</th>
        </tr>
        @for (wipetruck of planning.planning_wipetrucks; track wipetruck) {
            <tr>
                @if ((entities | byId: wipetruck.entity_id)?.use_once) {
                    <td>
                        {{ (entities | byId: wipetruck.entity_id)?.name }}
                    </td>
                }
                @if (!(entities | byId: wipetruck.entity_id)?.use_once) {
                    <td>
                        {{ wipetruck.name }}
                    </td>
                }
                <td>{{ wipetruck.begindate | date: 'EEE dd MMM' }}</td>
                <td>{{ wipetruck.begindate | date: 'H:mm' }} - {{ wipetruck.enddate | date: 'H:mm' }}</td>
                <td>{{ wipetruck.wdr }}</td>
                <td>{{ wipetruck.comment }}</td>
            </tr>
        }
    </table>
}
